{
  "slug": "how-is-iq-measured",
  "title": "IQ কিভাবে পরিমাপ করা হয়?",
  "description": "বুঝতে হবে, আইকিউ পরীক্ষার মান, বয়সভিত্তিক মানদণ্ড, সাবটেস্ট, পারসেনটিল এবং কেন প্রতিটি ফলাফল ভুলের মাত্রা আছে।",
  "summary": "IQ মানব মস্তিষ্কের কাজের মাধ্যমে পরিমাপ করা হয়। কৃত্রিম কার্যকারিতা বয়সভিত্তিক মানদণ্ডের সাথে তুলনা করা হয় এবং একটি স্কোরে পরিণত করা হয়, সাধারণত  এর উপর ভিত্তি করে। 100.",
  "sections": [
    {
      "heading": "কাজ থেকে একটি মানক স্কোর",
      "paragraphs": [
        "একটি মূল্যায়নে একাধিক সাব- টেস্ট অন্তর্ভুক্ত থাকে । একজন ব্যক্তি প্যাটার্ন সনাক্ত করতে পারেন, স্মৃতিতে তথ্য পরিবর্তন করতে পারেন, শব্দগত সমস্যা সমাধান করতে পারেন, অথবা সময়সীমার মধ্যে সঠিকভাবে কাজ করতে পারেন । কাঁচা মোট সংখ্যার নিজের জন্য খুব কম অর্থ আছে, তাই প্রকাশকরা তাদের একটি বড় রেফারেন্স নমুনার সাথে তুলনা করে।",
        "একই বয়সের লোকদের সাথে পারফরম্যান্সের তুলনা করা হয়। স্কেলে সাবটেস্ট স্কোরগুলোকে পরে বড় সূচক স্কোর এবং একটি সম্পূর্ণ অনুমানে একত্রিত করা যেতে পারে।"
      ]
    },
    {
      "heading": "নরম, পারসেনটিল এবং বিস্তার",
      "paragraphs": [
        "অনেক বর্তমান পরীক্ষার মধ্যে ব্যবহার করা হয় 100 এবং একটি মানদণ্ড বিভ্রাট 15. একটি শতাংশ অবস্থান প্রকাশ করে: 100 ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ ♪ 50% 1- তম শতাংশ, যখন 120 চারপাশে 91স্বাভাবিক বিতরণ অনুযায়ী ১ম শতাংশ",
        "বিভিন্ন যন্ত্র বিভিন্ন কাজ এবং নর্ম ব্যবহার করে, তাই দুইটি বৈধ পরীক্ষা সবসময় একই স্কোর তৈরি করে না।"
      ]
    },
    {
      "heading": "কেন ব্যাখ্যা গুরুত্বপূর্ণ",
      "paragraphs": [
        "প্রতিটি স্কোরের মধ্যে পরিমাপের অনিশ্চয়তা অন্তর্ভুক্ত থাকে এবং সাধারণত একটি বিশ্বাসযোগ্যতার ব্যবধানের সাথে রিপোর্ট করা উচিত। একজন প্রশিক্ষিত পরীক্ষার্থী সাবটেস্টের নকশা, ভাষা, সাংস্কৃতিক পটভূমি, পরীক্ষার শর্ত এবং মূল্যায়নের উদ্দেশ্যও বিবেচনা করে।",
        "ভাল পরিমাপ নির্ভর করে আদর্শ নির্দেশনা, উপযুক্ত নমুনা, পরীক্ষা নিরাপত্তা, বিশ্বাসযোগ্যতা এবং বৈধতা. এই প্রসঙ্গ ছাড়া একটি সংখ্যা ভুল হতে পারে।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "কেন কিছু IQ কাজ সময় নির্ধারিত?",
      "answer": "কিছু সাব-টেস্ট প্রক্রিয়াকরণের দক্ষতা পরিমাপ করে, কিন্তু অনেকগুলো যুক্তিমূলক কাজের সময়সীমা নেই অথবা তাদের সীমাবদ্ধতা আছে। সময়সীমা একটি মূল্যায়নের একটি অংশ মাত্র।"
    },
    {
      "question": "বিভিন্ন আইকিউ টেস্ট কি ভিন্ন ভিন্ন ফলাফল দিতে পারে?",
      "answer": "হ্যাঁ, বিষয়বস্তু, মানদণ্ড, পরিমাপের ভুল, স্বাস্থ্য এবং পরীক্ষার শর্তগুলি যৌক্তিক পার্থক্য সৃষ্টি করতে পারে।"
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
